import script from "./MessageCenter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageCenter.vue?vue&type=script&setup=true&lang=ts"

import "./MessageCenter.vue?vue&type=style&index=0&id=e5050138&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5050138"]])

export default __exports__